export function getBase64(file) {
  return new Promise((resolve, reject) => {
    if (typeof file === "object") {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    } else {
      resolve("none");
    }
  });
}